import React from 'react';

import { getRoles } from '../auth/roles';
import { useAuth } from 'react-oidc-context';

const IsAdmin = (props) => {
  const auth = useAuth();
  if (auth.isLoading) {
    return null;
  }
  if (getRoles(auth.user).includes("admin")) {
    return (
      <>
        {props.children}
      </>
    );
  }
  else return null;
}

export default IsAdmin;
